const colors = {
  red100: '#c3282d',
  grey120: '#444444',
  grey40: '#cedee4',
  grey20: '#dee9ed',
  grey10: '#f6f9fa',
};

export default colors;
